(() => {
  if (window.SlideshowWave) return;

  const SELECTOR = '.slideshow-bottom-wave[data-wave-animated]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();

  const sync = (wave) => {
    const state = instances.get(wave);
    if (!state || typeof state.svg.pauseAnimations !== 'function') return;

    if (reducedMotion.matches) {
      state.svg.pauseAnimations();
      state.svg.setCurrentTime(0);
    } else if (state.visible) {
      state.svg.unpauseAnimations();
    } else {
      state.svg.pauseAnimations();
    }
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const state = instances.get(entry.target);
            if (!state) return;
            state.visible = entry.isIntersecting;
            sync(entry.target);
          });
        })
      : null;

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((wave) => {
      if (instances.has(wave)) return;
      const svg = wave.querySelector('svg');
      if (!svg) return;

      instances.set(wave, { svg, visible: true });
      if (observer) observer.observe(wave);
      sync(wave);
    });
  };

  const destroy = (root) => {
    instances.forEach((_, wave) => {
      if (!root.contains(wave)) return;
      if (observer) observer.unobserve(wave);
      instances.delete(wave);
    });
  };

  reducedMotion.addEventListener('change', () => instances.forEach((_, wave) => sync(wave)));

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.SlideshowWave = { init, destroy };
})();
